import React, { Component, Fragment } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defaultTo, compose, last } from 'ramda';
import { withFormik } from 'formik';
import * as yup from 'yup';

import { apiAddAddress, apiUpdateAddress } from '../../api/user';
import { handleError, handleSuccess } from '../../util/forms';
import userActions from '../../redux/user/index';
import { isNilOrEmpty } from '../../util/redux';
import { getAddressComponents } from '../../util/helpers';

import Modal from '../Modal';
import EditField from '../Forms/EditField';
import AddressSearch from '../AddressSearch';
import Checkbox from '../Forms/Checkbox';

const mapDispatch = {
  ...userActions,
};

class AddressModal extends Component {
  static propTypes = {
    address: PropTypes.object,
    onHide: PropTypes.func,
    updateUserAddresses: PropTypes.func,
  };

  state = {
    show: false,
    isMilitary: false,
    finishedSearch: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState && !prevState.show && nextProps.show && nextProps.resetForm) {
      nextProps.resetForm();
      return { show: true, isMilitary: false, finishedSearch: false };
    }

    return { show: defaultTo(false, nextProps.show) };
  }

  render() {
    const {
      onHide,
      values,
      handleBlur,
      handleChange,
      handleSubmit,
      isSubmitting,
      isValid,
      status,
      setValues,
      setFieldValue,
    } = this.props;
    const { show, isMilitary, finishedSearch } = this.state;
    return (
      <Modal show={show} onHide={() => onHide()} title="Add Address">
        <form>
          <Modal.Body>
            <EditField
              block
              name="name"
              placeholder="Name"
              status={status}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.name}
            />
            <EditField
              block
              name="phone"
              placeholder="Phone"
              status={status}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.phone}
            />

            {isMilitary ? (
              <Fragment>
                <EditField
                  block
                  name="addressLine1"
                  placeholder="Address Line 1"
                  status={status}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.addressLine1}
                />
                <EditField
                  block
                  name="addressLine2"
                  placeholder="Address Line 2"
                  status={status}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.addressLine2}
                />
                <EditField
                  block
                  name="city"
                  placeholder="City, eg. APO, FPO, etc."
                  status={status}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.city}
                />

                {values.otherState ? (
                  <EditField
                    block
                    name="state"
                    placeholder="Type your State"
                    className="mb-0"
                    status={status}
                    onChange={({ target }) => setFieldValue('state', target.value.toUpperCase())}
                    onBlur={handleBlur}
                    value={values.state}
                  />
                ) : (
                  <EditField
                    as={Select}
                    bare
                    block
                    simpleValue
                    className="mb-0"
                    placeholder="State"
                    name="state"
                    status={status}
                    onChange={(value) => setFieldValue('state', value)}
                    onBlur={handleBlur}
                    value={values.state}
                    options={[
                      { value: 'AA', label: 'Armed Forces Americas' },
                      { value: 'AP', label: 'Armed Forces Pacific' },
                      { value: 'AE', label: 'Armed Forces Others' },
                      { value: 'AL', label: 'Alabama' },
                      { value: 'AK', label: 'Alaska' },
                      { value: 'AZ', label: 'Arizona' },
                      { value: 'AR', label: 'Arkansas' },
                      { value: 'CA', label: 'California' },
                      { value: 'CO', label: 'Colorado' },
                      { value: 'CT', label: 'Connecticut' },
                      { value: 'DE', label: 'Delaware' },
                      { value: 'DC', label: 'District Of Columbia' },
                      { value: 'FL', label: 'Florida' },
                      { value: 'GA', label: 'Georgia' },
                      { value: 'HI', label: 'Hawaii' },
                      { value: 'ID', label: 'Idaho' },
                      { value: 'IL', label: 'Illinois' },
                      { value: 'IN', label: 'Indiana' },
                      { value: 'IA', label: 'Iowa' },
                      { value: 'KS', label: 'Kansas' },
                      { value: 'KY', label: 'Kentucky' },
                      { value: 'LA', label: 'Louisiana' },
                      { value: 'ME', label: 'Maine' },
                      { value: 'MD', label: 'Maryland' },
                      { value: 'MA', label: 'Massachusetts' },
                      { value: 'MI', label: 'Michigan' },
                      { value: 'MN', label: 'Minnesota' },
                      { value: 'MS', label: 'Mississippi' },
                      { value: 'MO', label: 'Missouri' },
                      { value: 'MT', label: 'Montana' },
                      { value: 'NE', label: 'Nebraska' },
                      { value: 'NV', label: 'Nevada' },
                      { value: 'NH', label: 'New Hampshire' },
                      { value: 'NJ', label: 'New Jersey' },
                      { value: 'NM', label: 'New Mexico' },
                      { value: 'NY', label: 'New York' },
                      { value: 'NC', label: 'North Carolina' },
                      { value: 'ND', label: 'North Dakota' },
                      { value: 'OH', label: 'Ohio' },
                      { value: 'OK', label: 'Oklahoma' },
                      { value: 'OR', label: 'Oregon' },
                      { value: 'PA', label: 'Pennsylvania' },
                      { value: 'RI', label: 'Rhode Island' },
                      { value: 'SC', label: 'South Carolina' },
                      { value: 'SD', label: 'South Dakota' },
                      { value: 'TN', label: 'Tennessee' },
                      { value: 'TX', label: 'Texas' },
                      { value: 'UT', label: 'Utah' },
                      { value: 'VT', label: 'Vermont' },
                      { value: 'VA', label: 'Virginia' },
                      { value: 'WA', label: 'Washington' },
                      { value: 'WV', label: 'West Virginia' },
                      { value: 'WI', label: 'Wisconsin' },
                      { value: 'WY', label: 'Wyoming' },
                    ]}
                  />
                )}

                <Checkbox
                  name="otherState"
                  label="State not listed?"
                  checked={values.otherState}
                  onChange={handleChange}
                />

                <EditField
                  block
                  name="zip"
                  placeholder="Zip"
                  status={status}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.zip}
                />
              </Fragment>
            ) : finishedSearch ? (
              <Fragment>
                <EditField
                  block
                  name="addressLine1"
                  placeholder="Address Line 1"
                  status={status}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.addressLine1}
                />
                <EditField
                  block
                  name="addressLine2"
                  placeholder="Address Line 2"
                  status={status}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.addressLine2}
                />
                <div className="row form-group">
                  <div className="col-md-6">
                    <input
                      name="city"
                      placeholder="City"
                      className="form-control"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.city}
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      disabled
                      name="state"
                      placeholder="State / Province"
                      className="form-control"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.state}
                    />
                  </div>
                </div>
                <div className="row form-group">
                  <div className="col-md-6">
                    <input disabled name="zip" placeholder="Zip Code" className="form-control" value={values.zip} />
                  </div>
                  <div className="col-md-6">
                    <input
                      disabled
                      name="country"
                      placeholder="Country"
                      className="form-control"
                      value={values.country}
                    />
                  </div>
                </div>
              </Fragment>
            ) : (
              <div className="form-group">
                <label className="col-form-label">
                  Address Search (For military addresses, click{' '}
                  <button className="btn btn-link px-0" onClick={() => this.setState({ isMilitary: true })}>
                    here
                  </button>
                  )
                </label>
                <AddressSearch
                  placeholder="Search"
                  onChangeAddress={(addresses) => {
                    const address = getAddressComponents(addresses);
                    setValues({ ...values, ...address });
                    this.setState({ finishedSearch: true });
                  }}
                />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" onClick={() => onHide()}>
              Close
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isValid || isSubmitting}
              onClick={handleSubmit}
            >
              Save changes
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

export default compose(
  connect(null, mapDispatch),
  withFormik({
    handleSubmit: (payload, formProps) => {
      const { props } = formProps;
      const addressFunction = isNilOrEmpty(props.address) ? apiAddAddress : apiUpdateAddress;
      let newAddress = {};

      addressFunction(payload)
        .then(({ data }) => {
          newAddress = last(data);
          props.updateUserAddresses(data);
        })
        .then(() => handleSuccess(formProps))
        .then(() => props.onHide(newAddress.id))
        .catch((err) => handleError(formProps, err));
    },
    mapPropsToValues: ({ address = {} }) => ({
      id: address.id,
      name: defaultTo('', address.name),
      addressLine1: defaultTo('', address.addressLine1),
      addressLine2: defaultTo('', address.addressLine2),
      city: defaultTo('', address.city),
      state: defaultTo('', address.state),
      otherState: false,
      zip: defaultTo('', address.zip),
      country: defaultTo('', address.country),
      phone: defaultTo('', address.phone),
      lat: defaultTo('', address.lat),
      lng: defaultTo('', address.lng),
    }),
    validationSchema: () =>
      yup.object().shape({
        name: yup.string().required('Required'),
        addressLine1: yup.string().required('Required'),
        state: yup.string().required('Required'),
      }),
    isInitialValid: ({ initialValues, validationSchema }) => validationSchema().isValidSync(initialValues),
    validateOnChange: true,
  }),
)(AddressModal);
